import { LOGGING } from '@/services/api/userlog'
import { client } from '@/services/apolloclient'
import jwtDecode from 'jwt-decode'
import moment from 'moment'
moment.locale('id')
const accessRight = ['ADMIN', 'SUPER_ADMIN']

export const Helper = {
  methods: {
    /**
     * Current Date Time
     * @param {date} date
     * @returns
     */
    now() {
      return moment().toISOString()
    },
    /**
     * Current Date Time
     * @param {date} date
     * @returns
     */
    today() {
      const now = moment().format('YYYY-MM-DD')
      return [moment(`${now} 00:00:00`).toISOString(), moment(`${now} 23:59:59`).toISOString()]
    },
    /**
     * convert date to ISO String
     * @param {date} date
     * @returns
     */
    momentToISOString(date) {
      return moment(date).toISOString()
    },

    /**
     * convert date to YYYY-MM-DD (2022-12-31)
     * @param {date} date
     * @returns
     */
    momentYmD(date) {
      return moment(date).format('YYYY-MM-DD')
    },

    /**
     * convert date to YYYY-MM-DD (2022-12-31 12:55:22)
     * @param {date} date
     * @returns
     */
    momentYmDHms(date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },

    /**
     * convert date to DD MMMM YYYY HH:mm (31 Agustus 2022 12:55)
     * @param {date} date
     * @returns
     */
    momentDMYH(date) {
      return moment(date).format('DD MMMM YYYY HH:mm')
    },

    /**
     * convert date to DD MMMM YYYY HH:mm:ss (31 Agustus 2022 12:55:20)
     * @param {date} date
     * @returns
     */
    momentDMYHS(date) {
      return moment(date).format('DD MMMM YYYY HH:mm:ss')
    },

    /**
     * convert date to DD MMMM YYYY HH:mm (31 Agu 2022 - 12.55)
     * @param {date} date
     * @returns
     */
    momentDMY_HI(date) {
      return moment(date).format('DD MMM YYYY HH:mm')
    },

    /**
     * convert date to DD MMMM YYYY HH:mm (18 Agt 17:39)
     * @param {date} date
     * @returns
     */
    momentDMHm(date) {
      return moment(date).format('D MMM HH:mm')
    },

    /**
     * convert date to DD MMMM YYYY HH:mm:ss (18 Agt 17:39:00)
     * @param {date} date
     * @returns
     */
    momentDMHms(date) {
      return moment(date).format('DD MMM YYYY HH:mm:ss')
    },

    /**
     * convert date to DD MMM YYYY short month
     * @param {date} date
     * @returns
     */
    momentDateShortMonth(date) {
      return moment(date).format('DD MMM YYYY')
    },

    /**
     * convert date to DD MMM YYYY short month
     * @param {date} date
     * @returns
     */
    momentDateLongMonth(date) {
      return moment(date).format('DD MMMM YYYY')
    },

    /**
     * convert date to DD MMM YYYY short month
     * @param {date} date
     * @returns
     */
    momentTime(date) {
      return moment(date).format('HH:mm')
    },

    /**
     * convert date to HH:mm:ss short month
     * @param {date} date
     * @returns
     */
    momentTimeSeconds(date) {
      return moment(date).format('HH:mm:ss')
    },

    momentM(date) {
      return Number(moment(date).format('M'))
    },

    momentMMMMYYYY(date) {
      return moment(date).format('MMMM YYYY')
    },

    momentFirstAndEnd(date) {
      const currentDate = moment(date) // Get the current date
      const lastDayOfMonth = currentDate.clone().endOf('month') // Get the last day of the current month
      return [lastDayOfMonth._i.toISOString(), lastDayOfMonth._d.toISOString()]
    },

    momentY(date) {
      return Number(moment(date).format('YYYY'))
    },

    momentMMM(monthIndex) {
      return moment(Number(monthIndex), 'M').format('MMMM')
    },

    momentYYYYMMDDFromIndex(monthIndex, yearIndex) {
      return moment(`${yearIndex}-${monthIndex}-01 00:00:00`, 'YYYY-MM-DD HH:mm:ss').format(
        'YYYY-MM-DD HH:mm:ss'
      )
    },
    momentAdd(date, num, unit) {
      return moment(date).add(num, unit)
    },
    /**
     * Find range between 2 date
     * @param {date} startDate
     * @param {date} endDate
     * @returns
     */
    getDatesInRange(startDate, endDate) {
      startDate = new Date(startDate)
      endDate = new Date(endDate)
      let date = new Date(startDate.getTime())

      const dates = []

      while (date <= endDate) {
        dates.push(new Date(date))
        // date.setDate(date.getDate() + 1)
        date = date.getDate() + 1
      }

      return dates
    },

    /**
     * Convert number to time
     * @param {int} num
     * @returns
     */
    minuteToTime(num) {
      const d = Math.floor(num / 1440) // 60*24
      const h = Math.floor((num - d * 1440) / 60)
      const m = Math.round(num % 60)
      if (d !== 0) {
        return d + ' hari +'
      } else if (h !== 0) {
        return h + ' jam +'
      } else {
        return m + ' menit'
      }
    },

    /**
     * Get Grade from score
     * @param {int} score
     * @returns
     */
    getGrade(score) {
      if (score > 80) {
        return 'A'
      } else if (score <= 80 && score >= 61) {
        return 'B'
      } else if (score <= 60 && score >= 41) {
        return 'C'
      } else if (score <= 40 && score >= 21) {
        return 'D'
      } else {
        return 'E'
      }
    },

    /**
     * Get Company ID from Token
     * @param {int} score
     * @returns
     */
    getCompanyId() {
      const token = localStorage.getItem('token')
      if (!token) {
        return false
      }

      const decodedToken = jwtDecode(token)

      return decodedToken.companyId
    },

    /**
     * Get Logged in user name
     * @param {int} score
     * @returns
     */
    getUserName() {
      const token = localStorage.getItem('token')
      if (!token) {
        return false
      }

      const decodedToken = jwtDecode(token)

      if (!decodedToken) {
        return 'Guest'
      }

      return decodedToken.name
    },

    /**
     * Get Logged in user id
     * @param {int} score
     * @returns
     */
    getUserId() {
      const token = localStorage.getItem('token')
      if (!token) {
        return false
      }

      const decodedToken = jwtDecode(token)

      if (!decodedToken) {
        return null
      }

      return decodedToken.userId
    },

    /**
     *
     * @returns
     *
     */
    getAccessRight() {
      const token = localStorage.getItem('token')
      if (!token) {
        return false
      }

      const decodedToken = jwtDecode(token)

      if (decodedToken) {
        if (accessRight.includes(decodedToken.accessType)) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },

    /**
     * Get logged in user image
     * @param {int} score
     * @returns
     */
    getUserPhotoOLD() {
      const token = localStorage.getItem('token')
      if (!token) {
        return false
      }

      const decodedToken = jwtDecode(token)

      if (!decodedToken) {
        return 'https://api.dicebear.com/7.x/initials/svg'
      }

      return (
        decodedToken.image ||
        `https://api.dicebear.com/7.x/initials/svg?seed=${decodedToken.name}.svg`
      )
    },

    /**
     * Get logged in user image
     * @param {int} score
     * @returns
     */
    getUserPhoto() {
      const token = localStorage.getItem('token')
      if (!token) {
        return false
      }

      const decodedToken = jwtDecode(token)

      if (!decodedToken) {
        return 'https://api.dicebear.com/7.x/initials/svg'
      }

      return (
        decodedToken.image ||
        `https://api.dicebear.com/7.x/initials/svg?seed=${decodedToken.name}.svg`
      )
    },

    /**
     * Get Company Name from Token
     * @param {string} token
     * @returns
     */
    getCompanyNameFromToken(token) {
      if (!token) {
        return false
      }

      const decodedToken = jwtDecode(token)

      return decodedToken.companyName
    },

    /**
     * Get Logged in user name from token
     * @param {string} token
     * @returns
     */
    getUserNameFromToken(token) {
      if (!token) {
        return false
      }

      const decodedToken = jwtDecode(token)

      if (!decodedToken) {
        return 'Guest'
      }

      return decodedToken.name
    },

    /**
     * Get Logged in user id from token
     * @param {string} token
     * @returns
     */
    getUserIdFromToken(token) {
      if (!token) {
        return false
      }

      const decodedToken = jwtDecode(token)

      if (!decodedToken) {
        return null
      }

      return decodedToken.userId
    },

    /**
     * Get Logged in Access Rights from token
     * @param {string} token
     * @returns
     */
    getAccessFromToken(token) {
      if (!token) {
        return false
      }

      const decodedToken = jwtDecode(token)

      if (!decodedToken) {
        return null
      }

      return decodedToken.accessRight
    },

    /**
     * Check user if has access to edit / delete
     * @param {int} score
     * @returns
     */
    hasAccessEditAndDelete(dataCompanyId) {
      const companyId = this.getCompanyId()
      if (!companyId) {
        return false
      }

      if ((companyId === 1 && dataCompanyId === 1) || companyId === dataCompanyId) {
        return true
      }

      return false
    },

    /**
     * Check user if cant delete account
     * @param {int} dataUserId
     */
    cannotDelete(dataUserId) {
      const userId = this.getUserId()
      if (!userId) {
        return false
      }
      if (userId === dataUserId) {
        return true
      }

      return false
    },

    /**
     * Minimize float length to two digit
     * @param {float} score
     * @returns
     */
    minimizeFloat(data) {
      return parseFloat(data).toFixed(2)
    },

    /**
     * Get Days from Hours
     * @param {int} hours
     * @returns
     */
    getDaysFromHours(hours) {
      hours = parseFloat(hours)
      if (hours === 0) return 0
      if (hours < 24) return parseFloat(hours).toFixed(2)
      const days = hours / 24
      return parseFloat(days).toFixed(2)
    },

    /**
     * Check if hours is day or not
     * @param {int} hours
     * @returns
     */
    isDaysOrHours(hours) {
      hours = parseFloat(hours)
      if (hours === 0) return 'Jam'
      if (hours < 24) return 'Jam'

      return 'Hari'
    },

    /**
     * Convert time format to seconds integer
     * @param {int} hours
     * @returns
     */
    convertToSeconds(time) {
      if (time === null || time === '') return 0
      let timeArr = time.split(':')
      timeArr = timeArr.map((item) => parseInt(item))

      const hours = 3600 * timeArr[0]
      const minutes = 60 * timeArr[1]

      return hours + minutes + timeArr[2]
    },

    /**
     * Convert seconds integer to Time Format
     * @param {int} hours
     * @returns
     */
    convertToTime(time) {
      const secNum = parseInt(time, 10)
      let hours = secNum > 0 ? Math.floor(secNum / 3600) : Math.ceil(secNum / 3600)
      let minutes =
        secNum > 0
          ? Math.floor((secNum - hours * 3600) / 60)
          : Math.ceil((secNum - hours * 3600) / 60)
      let seconds = secNum - hours * 3600 - minutes * 60

      if (secNum < 0) {
        if (hours > -10) {
          hours = '-0' + hours
        }
        if (minutes > -10) {
          minutes = '-0' + minutes
        }
        if (seconds > -10) {
          seconds = '-0' + seconds
        }
      } else {
        if (hours < 10) {
          hours = '0' + hours
        }
        if (minutes < 10) {
          minutes = '0' + minutes
        }
        if (seconds < 10) {
          seconds = '0' + seconds
        }
      }
      return hours + ':' + minutes + ':' + seconds
    },

    /**
     * to Calculate Day from two date
     * @param {int} hours
     * @returns
     */
    calculateDay(date1, date2) {
      date1 = moment(date1)
      date2 = moment(date2)

      let diff = date1.diff(date2, 'days')

      if (diff < 0) diff *= -1

      return diff + 1
    },

    /**
     * to Calculate Day from date to now
     * @param {int} hours
     * @returns
     */
    calculateHours(date2) {
      const date1 = moment()
      date2 = moment(date2)

      let diff = date1.diff(date2, 'hours')

      if (diff < 0) diff *= -1

      return diff + 1
    },

    /**
     * to Calculate Day from date to now
     * @param {int} hours
     * @returns
     */
    calculateMinutes(date1, date2) {
      date1 = moment(date1)
      date2 = moment(date2)
      let diff = date1.diff(date2, 'minutes')

      if (diff < 0) diff *= -1

      return diff + 1
    },

    /**
     * user activity log
     * @param {*} action
     * @param {*} data
     */
    userLogging(action, data) {
      const input = {
        activity: action,
        path: `${data.name}`,
      }

      client.mutate({
        mutation: LOGGING,
        variables: {
          input,
        },
      })
    },

    /**
     * Duration to minutes
     */
    durationToMinutes(duration, durationOption) {
      const optionValue = {
        Menit: 1,
        Jam: 60,
        Hari: 1440,
        Minggu: 10080,
        Bulan: 43800,
      }

      return parseInt(duration) * optionValue[durationOption]
    },

    /**
     * Get Duration Option
     */
    getDurationOption(duration) {
      const optionValue = {
        Bulan: 43800,
        Minggu: 10080,
        Hari: 1440,
        Jam: 60,
        Menit: 1,
      }
      const keys = Object.keys(optionValue)
      let result = 'Menit'
      let resultValue = 0

      for (let index = 0; index < keys.length; index++) {
        if (duration % optionValue[keys[index]] === 0) {
          result = keys[index]
          resultValue = duration / optionValue[keys[index]]
          break
        }
      }

      return { value: resultValue, option: result }
    },

    isNumber(event) {
      event = event || window.event
      const charCode = event.which ? event.which : event.keyCode
      if ((charCode >= 48 && charCode <= 57) || charCode === 46) {
        return true
      } else {
        event.preventDefault()
      }
    },

    isDecimal(event) {
      event = event || window.event
      const charCode = event.which ? event.which : event.keyCode
      if (charCode >= 48 && charCode <= 57) {
        return true
      } else {
        event.preventDefault()
      }
    },

    isPhoneNumber(event) {
      event = event || window.event
      const charCode = event.which ? event.which : event.keyCode
      if (
        (charCode >= 48 && charCode <= 57) ||
        charCode === 40 ||
        charCode === 41 ||
        charCode === 45
      ) {
        return true
      } else {
        event.preventDefault()
      }
    },

    isPasteNumber(event) {
      const text = event.clipboardData.getData('text')
      const conditions = ['e', 'E', '-', '.', ',']
      if (conditions.some((val) => text.includes(val))) {
        event.preventDefault()
      }
    },

    isPastePhoneNumber(event) {
      const text = event.clipboardData.getData('text')
      const conditions = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '(', ')', '-']
      for (let i = 0; i < text.length; i++) {
        let state = false
        for (let j = 0; j < conditions.length; j++) {
          if (conditions[j] === text[i]) {
            state = true
            break
          }
        }
        if (state === false) {
          event.preventDefault()
          break
        }
      }
    },

    getCenter(arr) {
      let minX, maxX, minY, maxY
      for (let i = 0; i < arr.length; i++) {
        minX = arr[i].lat < minX || minX === null ? arr[i].lat : minX
        maxX = arr[i].lat > maxX || maxX === null ? arr[i].lat : maxX
        minY = arr[i].lng < minY || minY === null ? arr[i].lng : minY
        maxY = arr[i].lng > maxY || maxY === null ? arr[i].lng : maxY
      }
      // return [(minX + maxX) / 2, (minY + maxY) / 2];
      return {
        latitude: (minX + maxX) / 2,
        longitude: (minY + maxY) / 2,
      }
    },

    isAlphabetNumberOnly(e) {
      const char = String.fromCharCode(e.keyCode) // Get the character
      if (/^[A-Za-z0-9]+$/.test(char)) return true // Match with regex
      else e.preventDefault() // If not match, don't add to input text
    },
  },
}

export function debounce(fn, delay) {
  let timeoutID = null
  return function () {
    clearTimeout(timeoutID)
    const args = arguments
    const that = this
    timeoutID = setTimeout(function () {
      fn.apply(that, args)
    }, delay)
  }
}
